<template>
  <Teleport to="body">
    <Transition name="vendor-item-modal">
      <div
        v-if="show"
        class="vendor-item-modal-overlay"
      >
        <div
          ref="modalShellRef"
          class="vendor-item-modal-shell"
          :class="{ 'vendor-item-modal-shell--resizing': isResizing }"
          :style="vendorItemModalShellStyle"
          role="dialog"
          aria-modal="true"
          aria-labelledby="vendor-service-item-modal-title"
          title="Drag the bottom-right corner to resize"
          @click.stop
        >
          <header class="vendor-item-modal-header">
            <h2 id="vendor-service-item-modal-title" class="vendor-item-modal-header__title">
              Create Service Item
            </h2>
            <button
              type="button"
              class="vendor-item-modal-header__close"
              aria-label="Close"
              @click="handleClose"
            >
              <i class="bi bi-x-lg" aria-hidden="true"></i>
            </button>
          </header>

          <div class="vendor-item-modal-body">
            <VendorServiceItem
              :key="modalKey"
              is-modal
              :company-id-override="companyId"
              :preferred-vendor-id="preferredVendorId"
              @saved="handleSaved"
              @close="handleClose"
            />
          </div>

          <div
            class="vendor-item-modal-resize-handle"
            role="presentation"
            title="Resize"
            @mousedown.stop="startVendorItemModalResize"
          ></div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script>
import '../styles/vendor-item-modal.css';
import vendorItemModalResizeMixin from '@/modules/vendor/mixins/vendorItemModalResizeMixin.js';
import VendorServiceItem from '@/modules/vendor/views/VendorServiceItem.vue';

export default {
  name: 'VendorServiceItemModal',
  components: { VendorServiceItem },
  mixins: [vendorItemModalResizeMixin],
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    companyId: {
      type: [String, Number],
      required: true,
    },
    preferredVendorId: {
      type: [String, Number],
      default: '',
    },
  },
  emits: ['close', 'saved'],
  computed: {
    modalKey() {
      return `${this.companyId}-${this.preferredVendorId || 'none'}-${this.show ? 'open' : 'closed'}`;
    },
  },
  methods: {
    handleClose() {
      this.$emit('close');
    },
    handleSaved(item) {
      this.$emit('saved', item);
    },
  },
};
</script>
